(function () {
    'use strict';

    angular.module('tmx-app')
        .directive('tmxLeftbar', [tmxLeftbarDirective]);

    //Directive 
    function tmxLeftbarDirective() {
        var directive = {
            restrict: 'E',
            scope: {
                screenSize: '='
            },
            templateUrl: 'common/directives/leftbar/leftbar.html',
            controller: ['$mdSidenav', '$scope', '$state', 'menu', 'UsersService', 'CurrentUserService', 'tmxUtility','RoleManagementService', '$mdMedia', 'PrevilegeService',
                LeftBarCtrl],
            controllerAs: 'leftbarCtrl'
        };
        return directive;
    }
    //DIRECTIVE CONTROLLER

    function LeftBarCtrl($mdSidenav, $scope, $state, menu, UsersService, CurrentUserService,tmxUtility, RoleManagementService, $mdMedia,PrevilegeService) {
        //======Initializations========
        var toolbar = this;
        toolbar.config = {};
        toolbar.menu = menu;
        toolbar.roles = {};
        toolbar.defaultOpen = $mdMedia('gt-sm');        
        $scope.checkToggleVisibility = checkToggleVisibility;   
        
        toolbar.CheckStatePrevilege=PrevilegeService.CheckStatePrevilege;                   
         
        //getting Entity wise Privileges based on the currently logged in User's RoleID//

        function checkToggleVisibility(item){
            if(item.type === 'link'){
                return true;
            }
            if(item.pages) {
                var result = false;
                for(var i = 0 ;i<item.pages.length;i++){
                    result = PrevilegeService.CheckStatePrevilege('private.'+item.pages[i].route);
                    if(result) {       
                        return true;                 
                    }
                }
                return false;
            }              
        }
       
        toolbar.isOpen = isOpen;
        toolbar.toggleOpen = toggleOpen;

        toolbar.openPage = openPage;
        toolbar.status = {
            isFirstOpen: true,
            isFirstDisabled: false
        };


        //==========Functions=====================
      
        toolbar.toggleLeftbar = function(name){
            $mdSidenav(name).toggle();  
            $scope.screenSize = $mdSidenav(name).isOpen();
            if($scope.screenSize == false && menu.showMargin == false){
                $mdSidenav(name).toggle();  
                $scope.screenSize = $mdSidenav(name).isOpen();
            }
            menu.isOpen=$mdSidenav(name).isOpen();
            menu.showMargin=($scope.screenSize && $mdMedia('gt-sm'));
        };
    

        $scope.$on("toggleLeftbar", function () {
             
            toolbar.toggleLeftbar('left');
        }
        );

        function isOpen(section) {
            return menu.isSectionSelected(section);
        }

        function toggleOpen(section) {
            menu.toggleSelectSection(section);
        }

        function openPage(section) {
            if (section.type === 'link') {
                menu.selectPage($scope, section);
            }
        }           

        toolbar.gotoDashboard = function () {
            $state.go("private.inbox");
        };
        ////////////////////////////////////////////////////////////////////////////////
        toolbar.getScreenSize = function () {
            return $mdMedia('gt-sm') || $mdSidenav("left").isOpen();
        };
        toolbar.sizeChanged = function (newSize, oldSize) {
             
            if (newSize == oldSize) {
                return;
            }
            toolbar.screenSize = newSize;
            $scope.screenSize = toolbar.screenSize;
        };
        //watch for screen size
        $scope.$watch(toolbar.getScreenSize, toolbar.sizeChanged, true);

    }//directive controller end
})();